import { Helmet } from "react-helmet-async";

import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Comunidad from "../components/Comunidad";
import ProdeSection from "../components/ProdeSection";
import Burgers from "../components/Burgers";
import About from "../components/About";
import Foodtruck from "../components/Foodtruck";
import Team from "../components/Team";
import Footer from "../components/Footer";










export default function HomePage() {
  return (
    <>

      <>
        <Navbar />
        <Hero />
        <Comunidad />
        <ProdeSection />
        <Burgers />
        <About />
        <Foodtruck />
        <Team />
        <Footer />
      </>
    </>
  );
}